import { cn } from '@/shadcn-ui/utils';

interface InventoryNoStockProps {
  total?: number;
  className?: string;
}

export default function InventoryNoStock({ total, className }: InventoryNoStockProps) {
  return (
    <div
      className={cn(
        'flex w-full flex-col items-center justify-center gap-6 py-6',
        className
      )}
    >
      {total === undefined ? (
        <p className="body text-center">
          Sorry, we are unable to load vehicles at this time. Please try again later.
        </p>
      ) : (
        <>
          <h3 className="text-center">
            Due to extremely high demand we are currently out of stock in your market.
          </h3>
          <p className="body text-center">
            We&apos;re constantly adding cars, check back soon to see what&apos;s
            available.
          </p>
        </>
      )}
    </div>
  );
}
